<template>
  <div>
    <div class="content">
      <div class="form-container">
        <div class="vcore_container">
          <div class="vcore_row" v-if="enrollmentStep == 7">
            <div class="vcore_col--xs--12">
              <LogoDisplay :logo-src="logo"></LogoDisplay>
              <h2 class="form-title" tabindex="-1">Terms and Conditions</h2>
              <div
                class="form-description TermsConditionsClass"
                style="float:left;"
              >
                <p>
                  Important Information: Our bank complies with the USA PATRIOT
                  Act. This law mandates that we verify certain information
                  about you while processing your account application.
                </p>

                <p>
                  Application Authorization: By making this application, you
                  authorize Commerce Bank to make whatever credit inquiries
                  that we deem necessary in connection with this credit
                  application or in the course of review or collection of any
                  credit extended in relation to this application. You authorize
                  and instruct any person or consumer reporting agency to
                  complete and furnish us any information they may have or
                  obtain in response to such credit inquiries and agree that
                  such information, along with this application, shall remain
                  our property whether or not credit is extended. You have
                  answered the questions completely and correctly. Except in 
                  the states of Alabama or Nebraska or the territory of Puerto Rico,
                  you certify that you are 18 years of age (in AL or NE, you certify
                  that you are 19 years of age. in PR, you certify that you
                  are 21 years of age.) You agree to pay all charges on 
                  the requested CommerceCare<span class="sup">&reg;</span> Account when due. 
                  You are responsible for the entire Account
                  balance. You are hereby notified that a negative credit report
                  reflecting on your credit record may be submitted to a
                  consumer reporting agency if you fail to fulfill the terms of
                  your credit obligation.
                </p>

                <p>
                Sharing Information About your Application and Account:
                By submitting this application you give Commerce Bank
                explicit authorization to disclose personal information regarding
                your application to your designated healthcare provider to add
                transactions or make changes to your account balance. Information
                shared with your healthcare provider may include notification of 
                your credit underwriting decision, resulting in your account status, 
                and your available credit limit.  Your healthcare provider will 
                not be notified of your account payment status, however, they will 
                not be able to add transactions on your account if your account is 
                5 or more days past due.
                </p>

                <p>
                Military Lending Act Disclosure: Federal law provides important
                protections to members of the Armed Forces and their dependents
                relating to extensions of consumer credit. In general, the cost of 
                consumer credit to a member of the Armed Forces and his or her dependent
                may not exceed the annual percentage rate of 36 percent.
                This rate must include, as applicable to the credit transaction or account:
                The costs associated with credit insurance premiums; fees for
                ancillary products sold in connection with the credit transaction;
                any application fee charged (other than certain application fees for
                specified credit transactions or accounts); and any participation fee
                charged (other than certain participation fees for a credit card account).
                You can call toll free to 855-225-1576 to hear the applicable required
                Military Lending Act disclosures.
                </p>
                
                <p>
                  {{  consentVerbiage }}
                           
                </p>
                <p>
                  By clicking “Submit”, you certify that you have read and
                  agreed to all of the terms, conditions, and disclosures set
                  forth within this application. You are approving Commerce
                  Bank to request a credit report and process the information
                  set forth within this application as a credit application in
                  the same manner in which it would if you had completed a
                  signed paper application.
                </p>
                <div class="agreements">
                  <label for="agreement-one_checkbox" id="agreement-one" class="vcore_checkbox-group agreement">
                    <div class="vcore_checkbox">
                      <input id="agreement-one_checkbox" type="checkbox" class="vcore_checkbox-input" v-model="agreement"/>
                      <span class="vcore_checkbox-indicator"></span>
                    </div>
                    <span class="vcore_checkbox-label agreement_text">
                      I have read and agree to the Important Terms.
                    </span>
                  </label>
                  <div v-if="!agreement" class="termsWarning">
                    <i class="vcore_icon icon-warning termsWarningIcon"></i>
                    <span
                      >Accepting Important Terms is required to submit the
                      application.</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import LogoDisplay from "../components/LogoDisplay";
import { KEYS, getCustomBrandingByKey } from "@Shared/utils/CustomBranding";

export default {
  name: "Verify",
  components: {
    LogoDisplay
  },
  data() {
    return {
      agreement: false
     
    };
  },
  computed: {
    ...mapGetters(["institution", "formValues", "step", "enrollmentStep"]),
    logo() {
      return getCustomBrandingByKey(
        KEYS.CMC_LOGO,
        this.institution.cstmBrandingList
      );
    },

    consentVerbiage(){
     var verbaige = this.institution.consentVerbiage;   
     return verbaige;
    }

  },
  methods: {
    editInformation(value) {
      this.$router.push({ name: "Enroll" });
      this.$store.commit("SET_STEP", 1);
      this.$store.commit("SET_ENROLLMENTSTEP", value);
    }
  },
  watch: {
    agreement: {
      handler(val) {
        this.$store.commit("SET_ACCEPTED_AGREEMENTS", val);
      },
      immediate: true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "Verify" && this.enrollmentStep === 7) {
      this.$store.commit("SET_ENROLLMENTSTEP", this.enrollmentStep - 1);
      this.$emit("resetErrors");
    }
    next();
  }
};
</script>
<style lang="scss" scoped>
.content {
  border: 1px solid #d3d6de;
  border-top: 0;
  padding: 40px 35px;
  background-color: #ffffff;
  box-shadow: 0 2px 14px 0 rgba(119, 151, 178, 0.23);
  z-index: -1;
  margin-bottom: 20px;
  min-height: 635px;

  @media (max-width: $grid-breakpoint-sm) {
    // padding: 30px 0 10px;
    margin-bottom: 0;
    min-height: 0;
    border: none;
    box-shadow: none;
  }
}

.logo-display {
  display: none;

  @media (max-width: $grid-breakpoint-md) {
    display: inline-block;
    margin-bottom: 25px;
  }
}

p {
  margin-bottom: 5px;
}

.TermsConditionsClass p {
  margin-bottom: 25px;
  line-height: 30px;
}

.termsWarning {
  margin-top: 30px;
  color: #666;
  background-color: #fffae6;
  border: 1px solid #ffd006;
  display: block;
  overflow: hidden;
  width: 100%;
  padding: 0.875rem 0.75rem;

  i {
    margin-right: 8px;
    color: #ffd006;
  }
}
.sup {
    font-size: 70%;
    vertical-align: super;
}
</style>
